export default __webpack_public_path__ + "static/media/counter_red.aa3ec794.svg";